import Camera from './src/Camera.vue'

Camera.install = function(Vue) {
    Vue.component(Camera.name, Camera)
}

export default Camera